import axios from '@/libs/api.request'

export const upload = (file) => {
  return axios.request({
    url: 'files/upload',
    method: 'post',
    data: {
      file: file
    }
  })
}

export const dropFile = (fileId) => {
  return axios.request({
    url: 'files/' + fileId,
    method: 'delete'
  })
}

export const replaceFile = (fileId, file) => {
  return axios.request({
    url: 'files/' + fileId + '/replace',
    method: 'post',
    data: {
      file: file
    }
  })
}

export const attachFile = (attachableType, attachableId, fileIds) => {
  if (_.isNumber(fileIds)) {
    fileIds = [fileIds]
  }

  return axios.request({
    url: 'files/attach',
    method: 'post',
    data: {
      attachable: {
        type: attachableType,
        id: attachableId
      },
      fids: fileIds
    }
  })
}

export const getAttachments = (type, id) => {
  return axios.request({
    url: 'files/attachments?type=' + type + '&id=' + id,
    method: 'get'
  })
}

export const uploadThumbnail = (attachableType, attachableId, fileIds) => {
  if (_.isNumber(fileIds)) {
    fileIds = [fileIds]
  }
  return axios.request({
    url: 'files/thumbnail/associate',
    method: 'post',
    data: {
      model_type: attachableType,
      model_id: attachableId,
      fids: fileIds
    }
  })
}

export const deleteThumbnail = (attachableType, attachableId, fileIds) => {
  if (_.isNumber(fileIds)) {
    fileIds = [fileIds]
  }
  return axios.request({
    url: 'files/thumbnail',
    method: 'delete',
    data: {
      model_type: attachableType,
      model_id: attachableId,
      fids: fileIds
    }
  })
}
